<template>
  <v-container class="py-8 py-md-16">
    <v-row>
      <v-col cols="12" lg="6">
        <!-- <v-card-title class="px-0 text-h5"> Contáctanos </v-card-title> -->
        <HomeContactForm />
      </v-col>
      <v-col cols="12" lg="6">
        <!-- <v-card-title class="px-0 text-h5"> Contacto </v-card-title> -->
        <v-list
          density="compact"
          class="bg-transparent"
          aria-label="Información de contacto"
          role="list"
        >
          <v-list-item
            v-if="companyInfo.email"
            class="px-0 item-title--custom"
            link
            variant="plain"
            prepend-icon="$mdiEmail"
            :title="companyInfo.email"
            :href="`mailto:${companyInfo.email}`"
            :aria-label="`Contactar al correo electrónico: ${companyInfo.email}`"
          />
          <v-list-item
            v-if="companyInfo.address"
            class="px-0 item-title--custom text-wrap"
            link
            variant="plain"
            prepend-icon="$mdiMapMarker"
            :title="companyInfo.address"
            href="https://maps.app.goo.gl/2EmnztwqwtFyKJ338"
            target="_blank"
            :aria-label="`Dirección: ${companyInfo.address}`"
          />
          <v-list-item
            class="px-0 item-title--custom"
            link
            variant="plain"
            prepend-icon="$mdiWhatsapp"
            :title="companyInfo.tel"
            href="https://api.whatsapp.com/send?phone=584123210216"
            :aria-label="`Llamar al teléfono: ${companyInfo.tel}`"
          />
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import companyInfo from "~/data/companyInfo";
useSeoMeta({
  title: "Contacto",
  description: "Información de contacto y formulario para consultas.",
  ogTitle: "Contacto - " + companyInfo.name,
  ogDescription:
    "Ponte en contacto con nosotros a través de nuestro formulario o información de contacto.",
});
</script>

<style></style>
